import { WeightedMatch } from '../../../shared/types';
import { getTaxFullUrl } from '../../../shared/utils';

// Resolves null when no pro matched (the backend answers 204).
async function searchMatching(
  postalCode: string,
  terms: Record<string, string[]> = {},
  baseURL = getTaxFullUrl()
): Promise<WeightedMatch | null> {
  const fullUrl = `${baseURL}/api/matching/weighted-match`;
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ postalCode, terms })
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  if (response.status === 204) {
    return null;
  }
  return await response.json();
}

export { searchMatching };
